import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import AppForm from "../pages/AppForm";
import AppFormProvider from "../providers/AppFormProvider";
import ViewStateProvider from "../providers/ViewStateProvider";
import AFLandingPage from "../pages/AFLandingPage";
import AppFormInit from "../pages/AppFormInit";
import AFPersonalDetailspPage from "../pages/AFPersonalDetailsPage";
import AFContactDetailspPage from "../pages/AFContactDetailsPage";
import AFEligibilityPage from "../pages/AFEligibiltyPage";
import AFPolicyOwnership from "../pages/AFPolicyOwnership";
import AFPaymentOptionPage from "../pages/AFPaymentOptionPage";
import AFPaymentPage from "../pages/AFPaymentPage";
import AFAddressPage from "../pages/AFAddressPage";
import AFConsentPage from "../pages/AFConsentPage";
import AFSignaturePage from "../pages/AFSignaturePage";
import AFDeclarationsPage from "../pages/AFDeclarationsPage";
import AFSubmitPage from "../pages/AFSubmitPage";
import AFDonePage from "../pages/AFDonePage";
import { redirectTo404Page } from "../shared/AppFormHelper";


interface IAppFormRoutes {
    base: string;
}

const NotFoundPage: React.FC = () => {
    useEffect(() => {
        redirectTo404Page();
    }, []);
    return <></>;
};

const AppFormRoutes: React.FC<IAppFormRoutes> = ({ base }) => {
    return (
        <AppFormProvider>
            <ViewStateProvider>
                <Switch>
                    <Route exact path={base}>
                        <AppFormInit />
                    </Route>
                    <Route exact path={`${base}/setup/personal/:applicant`}>
                        <AFPersonalDetailspPage />
                    </Route>
                    <Route exact path={`${base}/setup/contact/:applicant`}>
                        <AFContactDetailspPage />
                    </Route>
                    <Route exact path={`${base}/eligibility/:applicant`}>
                        <AFEligibilityPage />
                    </Route>
                    <Route exact path={`${base}/details`}>
                        <AFLandingPage />
                    </Route>
                    <Route exact path={`${base}/details/:applicantToken`}>
                        <AppForm />
                    </Route>
                    <Route exact path={`${base}/details/:applicantToken/declarations`}>
                        <AFDeclarationsPage />
                    </Route>
                    <Route exact path={`${base}/submit/:applicationId/ownership`}>
                        <AFPolicyOwnership />
                    </Route>
                    <Route exact path={`${base}/submit/:applicationId/payment`}>
                        <AFPaymentOptionPage />
                    </Route>
                    <Route exact path={`${base}/submit/:applicationId/payment/:type/option`}>
                        <AFPaymentPage />
                    </Route>
                    <Route exact path={`${base}/submit/:applicationId/:applicant/address`}>
                        <AFAddressPage />
                    </Route>
                    <Route exact path={`${base}/submit/:applicationId/consent/:consent`}>
                        <AFConsentPage />
                    </Route>
                    <Route exact path={`${base}/submit/:applicationId/:applicant/signature`}>
                        <AFSignaturePage />
                    </Route>
                    <Route exact path={`${base}/submit/:applicationId/ready`}>
                        <AFSubmitPage />
                    </Route>
                    <Route exact path={`${base}/done/:applicationId`}>
                        <AFDonePage />
                    </Route>
                    <Route path={`${base}/*`}>
                        <NotFoundPage />
                    </Route>
                    </Switch>
                </ViewStateProvider>
        </AppFormProvider>
    );
};

export default AppFormRoutes;
